module.exports = {
      id: "pagePrev--4JdeK-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "static/sprites.cc394f91a99397d110cddb865416bf3d.svg#pagePrev--4JdeK-usage",
      toString: function () {
        return this.url;
      }
    }